import {LucideFlame} from 'lucide-react';

const BRAND_NAME = 'Fire Strike';
const MERKNU_URL = 'https://merknu.nl';

export const AppFooter = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative left-0 w-full bg-ink-950 border-t border-ink-700/70 text-ink-200 z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 flex flex-col items-center gap-5 text-center">

                <a href="/" className="flex items-center gap-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-fire-gradient shadow-ember-sm">
                        <LucideFlame className="h-5 w-5 text-white" />
                    </span>
                    <span className="font-display text-xl font-bold tracking-wide text-ink-50">
                        FIRE STRIKE
                    </span>
                </a>

                <p className="max-w-md text-sm text-ink-300">
                    Professionele magnesium vuurstarters voor survival, kamperen en avontuur.
                </p>

                <div className="w-full max-w-xs border-t border-ink-700/70 pt-5 flex flex-col gap-1">
                    <p className="text-sm text-ink-300">
                        {currentYear} © {BRAND_NAME}. All rights reserved.
                    </p>

                    <p
                        className="text-sm text-ink-400"
                        itemScope
                        itemType="https://schema.org/Organization"
                    >
                        <span itemProp="name" className="sr-only">Merknu</span>
                        <link itemProp="url" href={MERKNU_URL} />
                        Made by{' '}
                        <a
                            href={MERKNU_URL}
                            target="_blank"
                            rel="noopener"
                            title="Website laten maken door Merknu"
                            aria-label="Website made by Merknu — web development for local businesses"
                            className="font-semibold text-ember-400 underline-offset-2 hover:underline hover:text-ember-300 transition-colors"
                        >
                            Merknu
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};
